import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateDisplayFormatCell } from "../../helpers/CellGenerators";

export const DisplayFormatCell = ({ row }) => {
  return <TextDisplayCell value={generateDisplayFormatCell(row)} />;
};
